import {Component} from '@angular/core';
import {GetApplicationsService} from '../core/services/get-applications.service';
import {Globals} from '../globals';

@Component({
  selector: 'app-application-list',
  templateUrl: './application-list.component.html',
  styleUrls: ['./application-list.component.scss']
})

export class ApplicationListComponent {

  columnDefs = [
    {
      headerName: 'First Name',
      field: 'Brand_Profile_FirstName__c',
      sortable: true,
      filter: true,
      resizable: true,
      width: 160
    },
    {
      headerName: 'Last Name',
      field: 'Brand_Profile_Last_Name__c',
      sortable: true,
      filter: true,
      resizable: true,
      width: 160
    },
    {
      headerName: 'Personal Email',
      field: 'Personal_Email__c',
      width: 240
    },
    {
      headerName: 'Phone Number',
      field: 'Brand_Profile__r.Mobile_Phone__c',
      width: 145
    },
    {
      headerName: 'Start Date',
      field: 'Program_Start_Date_formula__c',
      sortable: true,
      filter: true,
      resizable: true,
      width: 150
    },
    {
      headerName: 'Program',
      field: 'Program_of_Interest_Name__c',
      sortable: true,
      filter: true,
      resizable: true,
      width: 200
    },
    {
      headerName: 'UVM Campus',
      field: 'UVM_Campus__c',
      sortable: true,
      filter: true,
      resizable: true,
      width: 180
    },
    {
      headerName: 'Created By',
      field: 'CreatedBy.Name',
      sortable: true,
      filter: true,
      resizable: true,
      width: 160
    },
    {
      headerName: 'Created Date',
      field: 'CreatedDate',
      sortable: true,
      filter: true,
      resizable: true,
      width: 175
    },
    {
      headerName: 'Laureate ID',
      field: 'Brand_Profile__r.UVM_Laureate_ID__c',
      sortable: true,
      filter: true,
      resizable: true,
      width: 165
    }
  ];

  public userRowData;
  public allRowData;
  public paginationPageSize;
  private gridApi;

  constructor(private appService: GetApplicationsService,
              public globals: Globals) {
    this.paginationPageSize = 20;
  }

  ngOnInit() {
    this.getUserApps();
    this.getAllApps();
  }

  getUserApps() {
    this.appService.getUserApps().subscribe(response => {
      this.userRowData = response;
    });
  }

  getAllApps() {
    this.appService.getAllApps().subscribe(response => {
      this.allRowData = response;
    });
  }

  onPageSizeChanged() {
    this.paginationPageSize = parseInt((<HTMLInputElement>document.getElementById('page-size')).value);
    this.gridApi.paginationSetPageSize(this.paginationPageSize);

  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }

}
